import { cn } from "../../lib/utils";
import type { Priority } from "../../data/types";

interface PriorityDotProps {
  priority: Priority;
  className?: string;
}

const colors: Record<Priority, string> = {
  critical: "bg-red-500 shadow-[0_0_6px_rgba(239,68,68,0.5)]",
  high: "bg-orange-400 shadow-[0_0_6px_rgba(251,146,60,0.4)]",
  medium: "bg-yellow-400",
  low: "bg-[#6B6E72]",
};

const labels: Record<Priority, string> = {
  critical: "Critical",
  high: "High",
  medium: "Medium",
  low: "Low",
};

export function PriorityDot({ priority, className }: PriorityDotProps) {
  return (
    <span
      className={cn("inline-block h-[7px] w-[7px] rounded-full shrink-0", colors[priority], className)}
      title={`Priority: ${labels[priority]}`}
    />
  );
}
